import { ApolloProvider } from "@apollo/client/react"
import React from "react"
import { createRoot } from "react-dom/client"

import App from "#Components/app"
import SettingsNavigation from "#Components/Navigation/SettingsNavigation"
import { tanstackRouter } from "#React/router/routeTree"
import { apolloClient } from "#Utils/apollo-client"
import { getData, onReady } from "#Utils/dom"
import { ReactQueryProvider } from "#Utils/react-query-client"
import { syncRouteTemplate } from "#Utils/routeTemplate"

onReady(async () => {
  const settingsNav = document.getElementById("react-nav")
  const settingsNavigationData = settingsNav?.getAttribute("data-settings-navigation")
  if (settingsNavigationData) {
    createRoot(settingsNav).render(
      <ApolloProvider client={apolloClient}>
        <ReactQueryProvider>
          <SettingsNavigation {...JSON.parse(settingsNavigationData)} />
        </ReactQueryProvider>
      </ApolloProvider>,
    )
  }

  // Check if there"s an app div, if so initialize the app in that div
  const app = document.getElementById("app")
  if (!app) return

  const body = document.body
  const root = createRoot(app)

  // Commit the matched route before first render. onResolved doesn't fire for
  // the initial load, so sync once explicitly; later navigations use the sub.
  tanstackRouter.subscribe("onResolved", syncRouteTemplate)
  await tanstackRouter.load()
  syncRouteTemplate()

  root.render(
    <ApolloProvider client={apolloClient}>
      <App
        site_name={getData(body, "site-name")}
        formatters={getData(body, "formatters")}
        platforms={getData(body, "platforms")}
        enabledLabFeatures={getData(body, "enabled-lab-features")}
        chartSettings={getData(body, "chart-settings")}
        restClientSettings={{
          endpoint: getData(body, "rest-endpoint"),
          token: getData(body, "rest-token"),
        }}
      />
    </ApolloProvider>,
  )
})
